module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feedbackPlaying === true),
      expression: "feedbackPlaying===true"
    }],
    staticClass: "feedback-lightbox",
    on: {
      "click": function($event) {
        _vm.stopFeedback()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('poly-video', {
    ref: "videoPlayer",
    attrs: {
      "playOnLoad": true,
      "vjsOptions": _vm.videoPlayerOptions,
      "sources": _vm.videoPlayerSources
    },
    on: {
      "error": _vm.onVideoPlayerError,
      "loadedsource": _vm.onVideoPlayerLoadedSource
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Term")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTerm),
      expression: "selectedTerm"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTerm = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.loadTermData()
      }]
    }
  }, _vm._l((_vm.terms), function(term) {
    return _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v("\n                    " + _vm._s(term.name) + "\n                ")])
  }))]), _vm._v(" "), (_vm.supervisors) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Supervisor")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSupervisor),
      expression: "selectedSupervisor"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSupervisor = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getFeedback]
    }
  }, _vm._l((_vm.supervisors), function(supervisor) {
    return _c('option', {
      domProps: {
        "value": supervisor.id
      }
    }, [_vm._v("\n                       " + _vm._s(supervisor.firstName) + " " + _vm._s(supervisor.lastName) + "\n                   ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.submissions) ? _c('div', {
    staticClass: "submissions nice-scrollbar"
  }, [_c('div', {
    staticClass: "week-jumper"
  }, [_c('span', {
    staticClass: "week-jumper-label"
  }, [_vm._v("Week")]), _vm._v(" "), _vm._l((14), function(week) {
    return _c('span', {
      staticClass: "week-jumper-week",
      on: {
        "click": function($event) {
          _vm.jumpToWeek(week)
        }
      }
    }, [_vm._v("\n                       " + _vm._s(week) + "\n                   ")])
  })], 2), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.submissions), function(submission) {
    return _c('tr', {
      class: 'submission-' + submission.week
    }, [_c('td', [_vm._v(_vm._s(submission.week))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(submission.assignmentName))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'student',
          params: {
            studentId: submission.student.populiId
          },
          query: {
            userId: submission.student.id,
            term: _vm.selectedTerm
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n                                   " + _vm._s(submission.student.firstName) + " " + _vm._s(submission.student.lastName) + "\n                               ")])], 1), _vm._v(" "), _c('td', [(submission.url) ? _c('span', [_vm._l((submission.url), function(link, $index) {
      return _c('a', {
        attrs: {
          "href": link,
          "target": "_blank"
        }
      }, [($index > 0) ? _c('span', [_vm._v("/")]) : _vm._e(), _vm._v(" File " + _vm._s($index + 1) + " \n                                   ")])
    }), _vm._v(" "), (submission.comments) ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: (submission.comments),
        expression: "submission.comments"
      }],
      staticClass: "clippie fa fa-comment cursor-pointer"
    }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "feedback-meta"
    }, [_vm._v("\n                                   " + _vm._s(_vm._f("shortDate")(submission.createdAt)) + "\n                               ")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(submission.feedback) ? _c('span', [_c('a', {
      staticClass: "feedback-link cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.loadFeedback(submission.feedback)
        }
      }
    }, [_c('img', {
      staticClass: "play-button",
      attrs: {
        "src": require("../../assets/img/play-button-small-green.png")
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "feedback-meta"
    }, [_vm._v("\n                                       " + _vm._s(_vm._f("shortDate")(submission.feedback.createdAt)) + "\n                                ")]), _vm._v(" "), (submission.feedback.duration || submission.feedback.duration === 0) ? _c('span', {
      staticClass: "feedback-meta"
    }, [_vm._v("\n                                        " + _vm._s(Math.round(submission.feedback.duration / 60)) + " min\n                                \n                                    ")]) : _c('span', {
      staticClass: "feedback-meta"
    }, [_vm._v("\n                                        Loading length...\n                                    ")])]) : _c('span', [_vm._v("\n                                   No feedback\n                               ")])])])
  }))])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Week")]), _vm._v(" "), _c('th', [_vm._v("Assignment")]), _vm._v(" "), _c('th', [_vm._v("Student Name")]), _vm._v(" "), _c('th', [_vm._v("Submission")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Feedback")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00c1998a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/DirectorFeedback.vue
// module id = 1957
// module chunks = 2